import axiosInstance from "./axiosConfig";

const normalizeUrl = (url) => String(url || '').replace(/^\/+/, '');

const rejectHtmlResponse = (response) => {
  const contentType = response?.headers?.['content-type'] || '';
  const data = response?.data;
  const isHtml =
    contentType.includes('text/html') ||
    (typeof data === 'string' && /<html|<!doctype html/i.test(data));

  if (isHtml) {
    return Promise.reject({
      response,
      message: 'API returned an HTML page instead of JSON. Please check live API bot/security settings.'
    });
  }

  return response;
};


export function getRequest(URL, headers = null) {
  return axiosInstance.get(normalizeUrl(URL), headers).then(rejectHtmlResponse);
}


export function postRequest(URL, payload, headers = null) {
  return axiosInstance.post(normalizeUrl(URL), payload, headers)
    .then(rejectHtmlResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

export function patchRequest(URL, payload, headers = {}) {
  return axiosInstance
    .patch(normalizeUrl(URL), payload, headers)
    .then(rejectHtmlResponse)
    .catch(error => {
      throw error; // Don't just console.log it — rethrow to catch in caller
    });
}


export function deleteRequest(URL, headers = null) {
  return axiosInstance.delete(normalizeUrl(URL), headers).then(rejectHtmlResponse)
  .catch((error)=> console.log(error));
}
